module.exports = __webpack_public_path__ + "assets/images/img-46c61f3fdaf5863bdf0fc85dbb927c95.png";